import { render, staticRenderFns } from "./DashboardFacebookAdCard.vue?vue&type=template&id=fbde8df8&"
import script from "./DashboardFacebookAdCard.vue?vue&type=script&lang=js&"
export * from "./DashboardFacebookAdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports